/**
 * Keeps the sliding cart (#halo-cart-sidebar) in sync with cart changes made
 * outside the theme — e.g. the Discounty free-gift popup, which POSTs straight
 * to /cart/add.js without going through halo.actionAddToCart.
 *
 * The theme only re-renders the sidebar from its own add-to-cart handlers, so
 * an external add leaves an already-open sidebar showing stale markup until it
 * is closed and reopened. Here we watch fetch/XHR for cart mutations and run
 * the same refresh the theme would have run.
 */
(function () {
    'use strict';

    var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/i;
    var DEBOUNCE = 300; // let the app finish any follow-up requests first
    var SKIP_WINDOW = 1200; // ignore changes the theme has just rendered itself

    var timer = null;

    function isCartMutation(url) {
        if (!url) return false;

        try {
            return CART_MUTATION.test(String(url).split('#')[0]);
        } catch (e) {
            return false;
        }
    }

    function themeAlreadyHandledIt(halo) {
        return halo.sidebarCartRefreshing === true || Date.now() - (halo.sidebarCartRefreshedAt || 0) < SKIP_WINDOW;
    }

    function refresh() {
        var halo = window.halo,
            $ = window.jQuery;

        if (!halo || !$ || typeof window.Shopify === 'undefined' || typeof Shopify.getCart !== 'function') return;
        if (themeAlreadyHandledIt(halo)) return;

        Shopify.getCart(function (cart) {
            var $body = $('body');

            $body.find('[data-cart-count]').text(cart.item_count);

            // Re-check: the theme may have started its own refresh while /cart.js was in flight.
            if (themeAlreadyHandledIt(halo)) return;

            if ($body.hasClass('template-cart')) {
                halo.updateCart(cart);
            } else if ($body.hasClass('cart-sidebar-show')) {
                halo.updateSidebarCart(cart);
            }
        });
    }

    function scheduleRefresh() {
        clearTimeout(timer);
        timer = setTimeout(refresh, DEBOUNCE);
    }

    if (window.fetch) {
        var nativeFetch = window.fetch;

        window.fetch = function (input, init) {
            var url = input && input.url ? input.url : input,
                request = nativeFetch.apply(this, arguments);

            if (isCartMutation(url)) {
                request
                    .then(function (response) {
                        if (response && response.ok) scheduleRefresh();
                    })
                    .catch(function () {});
            }

            return request;
        };
    }

    var nativeOpen = XMLHttpRequest.prototype.open,
        nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
        this.haloCartRequestUrl = url;
        return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
        if (isCartMutation(this.haloCartRequestUrl)) {
            this.addEventListener('load', function () {
                if (this.status >= 200 && this.status < 300) scheduleRefresh();
            });
        }

        return nativeSend.apply(this, arguments);
    };

    // Some apps announce cart changes instead of (or as well as) hitting the Ajax API.
    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (eventName) {
        document.addEventListener(eventName, scheduleRefresh);
    });
})();
